import Container = Phaser.GameObjects.Container;
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";

export class MenuNewElementMarker extends Container {


    constructor(scene: Scene, x: number, y: number, content: string) {
        super(scene);

        let newElementText = TextUtils.addTextAdvanced(this.scene, content.toLowerCase(), x, y, '#79ea02',
            12, 'italic', 150, 'center', 2, Fonts.BENGALY_NORMAL);

        this.add(newElementText);
    }
}